"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sha256_1 = __importDefault(require("crypto-js/sha256"));
const event_agent_1 = require("./utils/event.agent");
/** The event tracker class that handles sending monitoring events. */
class EventTracker {
    /**
     * Create an event tracker instance.
     * @param authService - OIDC AuthService instance.
     * @param appName - The application name.
     */
    constructor(authService, appName) {
        this.appName = appName;
        this.authService = authService;
    }
    /**
     * Get and normalize the user data.
     * @param [userData] - the current user data object.
     * @returns a Promise with a normalized user data.
     */
    getUserData(userData) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            const user = userData || (yield this.authService.getUser());
            if (!user)
                return;
            return {
                appName: this.appName,
                at: sha256_1.default(user.access_token).toString(),
                clientId: (_a = user.profile) === null || _a === void 0 ? void 0 : _a.client_id,
                exp: user.expires_at,
                iat: (_b = user.profile) === null || _b === void 0 ? void 0 : _b.auth_time,
                isAdmin: !!((_c = user.profile) === null || _c === void 0 ? void 0 : _c.adminId),
                isAttendant: !!((_d = user.profile) === null || _d === void 0 ? void 0 : _d.attendantId),
                referer: window.location.origin,
                route: window.location.pathname + window.location.search,
                sid: (_e = user.profile) === null || _e === void 0 ? void 0 : _e.sid,
                tgt: sha256_1.default((_f = user.profile) === null || _f === void 0 ? void 0 : _f.jti).toString(),
                ucode: (_g = user.profile) === null || _g === void 0 ? void 0 : _g.ucode
            };
        });
    }
    /**
     * Send event for monitoring application.
     * @param entity - event entity
     * @param payload - event payload
     * @param [user] - current user data
     */
    send(entity, payload, user) {
        return __awaiter(this, void 0, void 0, function* () {
            const event = yield this.getUserData(user);
            if (!event)
                return;
            event_agent_1.sendDatahub(entity, Object.assign(Object.assign({}, event), payload));
        });
    }
}
exports.default = EventTracker;



//////////////////
// WEBPACK FOOTER
// ./~/@hotmart/cas-js/dist/event.tracker.js
// module id = 727
// module chunks = 0